import React, {useContext} from "react";
import {useViewerStore} from "../../../../../../../store/store";
import TreeCartForm from "../TreeCartForm";
import {METER, TREE, UnitContext} from "../../../../../../../contexts/UnitContext";
import {ChangeTreeDelete} from "../../../../Three-JS-Viewer/Controllers/ObstructionControl";
import {ImArrowUp} from "react-icons/im";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { MdOutlineSort } from "react-icons/md";
import { Button , Col, Row , Dropdown, Space} from "antd";
import {removeSelectedTree} from "../../../../../../../helpers/storeHelpers";
import { TreeGroup } from "../../../../../../../@types/types";
import { MeshType, TreeProperty } from "../../../../../../../@types/enums";
import * as THREE from 'three';

const TreeInfoTable: React.FC = () => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const {treeUnit, convertTypeQuantityToUnit, renderUnit} = useContext(UnitContext);

    const treeColumn = [
        {title: 'Tree ID', key : "treeId"},
        {title: 'Diameter'},
        {title: 'Height'},
        {title: 'Multiplier', key : "multiplier"},
        {title: 'Add to Cart'}
    ];

    const {treeCartItems} = useViewerStore();

    const [, updateState] = React.useState<{}>();
    const [sortConfig, setSortConfig] = React.useState({ key: 'treeId', direction: 'asc' });

    const customTreeIdSort = (a: TreeGroup, b: TreeGroup) => {
        const isSpecial = (treeId: string) => /^[A-Z]{2,}$/.test(treeId); 

        const aSpecial = isSpecial(a.userData.treeId);
        const bSpecial = isSpecial(b.userData.treeId);

        if (aSpecial && !bSpecial) return 1; 
        if (!aSpecial && bSpecial) return -1; 
        if (aSpecial && bSpecial) return a.userData.treeId.localeCompare(b.userData.treeId); 

        return a.userData.treeId.localeCompare(b.userData.treeId); 
    };

    const sortedData = sceneViewer?.treeGroup.children?.slice().sort((a: TreeGroup, b: TreeGroup) => {
        if (sortConfig.key === 'treeId') {
            return sortConfig.direction === 'asc' ? customTreeIdSort(a, b) : -customTreeIdSort(a, b);
        } else if (sortConfig.key === 'multiplier') {
            return sortConfig.direction === 'asc' ? Number(a.userData.multiplier?.value) - Number(b.userData.multiplier?.value) : Number(b.userData.multiplier?.value) - Number(a.userData.multiplier?.value);
        }
        return 0;
    });

    const requestSort = (key: string) => {
        let direction = key === 'treeId' ? 'asc' : 'desc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const forceUpdate = React.useCallback(() => updateState({}), []);

    const addToCart = (treeId: string) => {
        const existInCart = useViewerStore.getState().treeCartItems.find((tree) => tree.userData.treeId === treeId)
        if (existInCart) {
            alert('This tree is already in cart');
            return;
        }

        const selectedTree = sceneViewer.treeGroup.children.find((tree: TreeGroup) => tree.userData.treeId === treeId);
        selectedTree.userData.treeCartInfo = {};
        selectedTree.userData.treeCartInfo.isFormUpdated = true;

        sceneViewer.selTreeArr = [selectedTree]
        //Add Tree Form
        sceneViewer.viewerAlert({
            show: true,
            title: "Fill Tree Info",
            message: <TreeCartForm
                selectedTrees={[selectedTree]}
                onSubmit={() => {
                    sceneViewer.setTreeProperty(TreeProperty.delete);
                    forceUpdate();
                }}
            />,
            messageType: "info",
            isModal: true,
        })
    }

    const removeFromCart = (treeId: string) => {
        let treeInCart = useViewerStore.getState().treeCartItems.find((tree) => tree.userData.treeId === treeId);

        if (treeInCart) {
            treeInCart.userData.treeCartInfo = {
                dbh: '',
                haul: '',
                height: '',
                isFormUpdated: false,
                location: '',
                noOfObst: 0,
                stump: '',
                total: 0,
            };
            treeInCart.select = false;
            removeSelectedTree(treeInCart);
            const child = treeInCart.children[0];
            if (child instanceof THREE.Mesh && 'emissive' in child.material) {
                (child.material as THREE.MeshStandardMaterial).emissive.setHex(0x000000);
            }

            //Remove Tree from cart based on selected tree id
            let updatedCartTrees = useViewerStore.getState().treeCartItems.filter((tree) => tree.userData.treeId !== treeId);

            ChangeTreeDelete(treeInCart, false);
            forceUpdate();
            sceneViewer.refreshShade(false);
            useViewerStore.setState({treeCartItems: updatedCartTrees});
        }
    }

    const highLightTree = (treeId: string, value: boolean) => {
        sceneViewer.treeGroup.children.forEach((tree: TreeGroup) => {
            if (tree.userData.treeId === treeId) {
                const child = tree.children[0];
                if (child instanceof THREE.Mesh && 'emissive' in child.material) {
                    (child.material as THREE.MeshStandardMaterial).emissive.set(value ? 0x0000ff : 0x000000);
                }
            }
        });
    };

    const items = [
        {key: 'treeId', label: 'Tree ID'},
        {key: 'multiplier', label: 'Multiplier'},
    ]

    const handleMenuClick = (e: any) => {
        requestSort(e.key)
      };
    return (
        <div className={"tab-content-container"}>
            <Row className="mb-1" style={{alignItems: "baseline"}}>
                <Col lg={12} md={12}>
                </Col>
                <Col lg={12} md={12} style={{display: "flex", justifyContent: "flex-end"}}>
                    <Dropdown
                       menu={{
                        items,
                        onClick: handleMenuClick,
                        activeKey:sortConfig.key
                        }}
                       placement="bottom"
                       arrow
                    >
                        <Space>
                            <Button type='primary' size="middle" icon={<MdOutlineSort size={22}/>} title="Sort"></Button>
                        </Space>
                    </Dropdown>
                </Col>
            </Row>   
            <div className={"tab-content-scrollable-container"}>
            <table className="tab__table">
                <thead>
                <tr>
                    {treeColumn.map((item, index) => (
                        <th key={index} align="center" onClick={item.key ? () => requestSort(item.key) :undefined}>
                            {item.title}
                            {sortConfig.key === item.key ? (
                                sortConfig.direction === 'asc' ? 
                                <FaSortUp size={14} style={{verticalAlign:"bottom", marginLeft:"6px"}}/> 
                                : <FaSortDown  size={14} style={{verticalAlign:"top", marginLeft:"6px"}}/>
                            ) :  item.key? (
                                <FaSort size={14} style={{verticalAlign:"sub", marginLeft:"6px"}}/>
                            ): null
                        }
                        </th>
                    ))}
                </tr>
                </thead>

                <tbody>
                {sortedData?.map((data: TreeGroup, index: number) => (
                    <tr key={index}
                        onMouseEnter={() => highLightTree(data.userData.treeId, true)}
                        onMouseLeave={() => highLightTree(data.userData.treeId, false)}
                    >
                        <td align="center">
                            {data.userData.treeId}
                        </td>
                        <td align="center">
                            {convertTypeQuantityToUnit(TREE as MeshType.Tree, Number(data.userData.crown_radius), METER).toFixed(2)} {renderUnit(treeUnit)}
                        </td>
                        <td align="center">
                            {convertTypeQuantityToUnit(TREE as MeshType.Tree, data.userData.height, METER).toFixed(2)} {renderUnit(treeUnit)}
                        </td>
                        <td align="center"
                            style={{"background": '#545b61', "color": data.userData.multiplier?.color}}>M <ImArrowUp
                            size={10}/>{data.userData.multiplier?.value}</td>
                        <td align="center">
                            {treeCartItems?.filter((tree) => tree.userData.treeId === data.userData.treeId).length > 0 ? (
                                <button
                                    style={{width: '100px', height: '30px', scale: 0.5, backgroundColor: 'indianred'}}
                                    id={data.userData.treeId}
                                    onClick={(e) => removeFromCart((e.target as HTMLButtonElement).id)}
                                    className="btn-primary small">
                                    Remove
                                </button>
                            ) : (
                                <button
                                    style={{width: '100px', height: '30px', scale: 0.5, backgroundColor: 'seagreen'}}
                                    id={data.userData.treeId}
                                    onClick={(e) => addToCart((e.target as HTMLButtonElement).id)}
                                    className="btn-primary btn-sm">
                                    Add
                                </button>
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>


            </div>


        </div>

    )
}

export default TreeInfoTable;